module.exports = __webpack_public_path__ + "img/box_deyi.25c76f75.svg";